import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_play-in-circle",
  "use": "svg_play-in-circle-usage",
  "viewBox": "0 0 92 92",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 92 92\" id=\"svg_play-in-circle\"><circle opacity=\".8\" cx=\"46\" cy=\"46\" fill=\"#fff\" r=\"46\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M36.424 27.87a1.826 1.826 0 0 1 1.872.085l24.84 16.432a1.826 1.826 0 0 1 0 3.045l-24.84 16.433a1.826 1.826 0 0 1-2.833-1.523V29.477c0-.672.37-1.29.961-1.608Z\" fill=\"#00AEEF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol